// @ts-ignore
import "quill-mention";
import { useMemo } from "react";
import useWorkspace from "../../api/api-hooks/workspaces/useWorkspace";
import useUser from "../../api/api-hooks/auth/useUser";

const empty: [] = [];

// https://github.com/quill-mention
export default function useMentionsModule(disabled: boolean) {
  const { workspaceLoading, workspaceMembers } = useWorkspace();
  const { user } = useUser();

  const userID = user?.id;

  const users = useMemo(() => {
    if (
      disabled ||
      !Array.isArray(workspaceMembers) ||
      !workspaceMembers.length
    ) {
      return empty;
    }

    return workspaceMembers.flatMap((member) =>
      member?.PersonID && member?.Data && member?.PersonID !== userID
        ? { id: member?.PersonID, value: member?.Data?.Name }
        : []
    );
  }, [workspaceMembers, disabled, userID]);

  const mentionsModule = useMemo(() => {
    if (disabled || workspaceLoading) return null;

    return {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ["@"],
      source: (searchTerm: string, renderList: any) => {
        if (searchTerm.length === 0) {
          renderList(users, searchTerm);
        } else {
          const matches = [];

          for (let i = 0; i < users.length; i++) {
            if (~users[i].value.toLowerCase().indexOf(searchTerm.toLowerCase()))
              matches.push(users[i]);
          }

          renderList(matches, searchTerm);
        }
      },
      positioningStrategy: "fixed",
      defaultMenuOrientation: "top",
    };
  }, [disabled, workspaceLoading, users]);

  return { mentionsModule };
}
